import BookingManagement from './booking_management';

export default BookingManagement;
